<template>
  <div class="history_">
    <div class="his-title">
      <div class="star-header">
        <img alt="" src="@/assets/images/powderedMilk/selection.png">
        <span class="head-title">用心呵护全家健康</span>
      </div>
      <div class="content">
        <div v-for="(item,index) in info" class="subject" @click="Tolist(item.parentId,item.name)">
          <img :src="item.img" alt="" class="image">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Index from "./js/index.js";

export default Index;
</script>
<style lang="less" scoped>
@import "./less/index.less";
</style>
